import React, { useEffect, useState } from 'react';
import MasterLayout from '../../layouts/MasterLayout';
import ThemeBreadcrumb from '../../components/themes/ThemeBreadcrumb';
import AppNotification from '../../helpers/AppNotification';
import Paginate from '../../components/paginate/Paginate';
import IpSettingModel from '../../models/IpSetting';
import {setShowPreloader} from "../../redux/action";
import Swal from "sweetalert2";
import {useDispatch} from "react-redux";


function IPSettingPage(props) {
    // paginate
    const dispatch = useDispatch();
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState({});
    const changePage = (page) => {
        setPage(page);
    }
    const handleSetPage = (number) => {
        setPage(page + number);
    }

    const [data, setData] = useState([]);
    const [ip, setIp] = useState('');
    const [type, setType] = useState('');
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState({
        search: '',
        type: type,
        perPage: perPage,
        page: page,
    });

    const handleChangeperPage = (e) => {
        setPerPage(e.target.value);
        setPage(1);
    }

    const handleChange = (event) => {
        setSearch(event.target.value);
    };

    const handleChangeType = (event) => {
        setType(event.target.value);
    };

    const resetFilter = (event) => {
        setType('');
        setSearch('');
        setFilter({ search: '', type: ''});
        setPage(1);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setFilter({ search: search, type: type});
    }

    useEffect(() => {
        IpSettingModel.getAll(
            {
                search: filter.search,
                type: type,
                page: page,
                perPage: perPage
            }
        ).then((res) => {
            setData(res.data);
            setMeta(res.meta);
        }).catch((err) => {
            console.log(err);
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    }, [page, filter])

    const handleDeleteIp = (id) => {
        const confirmDelete = window.confirm("Bạn có chắc chắn muốn xóa IP này?");
        if (confirmDelete) {
            dispatch(setShowPreloader(true));
            IpSettingModel.delete({
                id: id,
            })
                .then((res) => {
                    dispatch(setShowPreloader(false));
                    Swal.fire({
                        icon: "success",
                        title: "Xoá IP thành công!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    setTimeout(() => {
                        reloadPage();
                    }, 2000);
                })
                .catch((err) => {
                    dispatch(setShowPreloader(false));
                    console.log(err);
                    Swal.fire({
                        icon: "error",
                        title: "Xoá IP thất bại!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    AppNotification.showError("Xoá IP thất bại!");
                });
        }
    };

    const reloadPage = () => {
        window.location.reload();
    };

    const handleSubmitForm = () => {
        dispatch(setShowPreloader(true));
        IpSettingModel.createIP({
            ip: ip,
        })
            .then((res) => {
                if (res.success === true) {
                    dispatch(setShowPreloader(false));
                    Swal.fire({
                        icon: "success",
                        title: res.message,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    setTimeout(() => {
                        reloadPage();
                    }, 2000);
                } else {
                    dispatch(setShowPreloader(false));
                    Swal.fire({
                        icon: "error",
                        title: res.message,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }).catch(err => {
            dispatch(setShowPreloader(false));
            console.log(err);
        })
    };

    const handleChangeIP = (event) => {
        setIp(event.target.value);
    };

    const changeStatus = (id) => {
        IpSettingModel.changeStatus({
            id: id,
        })
            .then((res) => {
                dispatch(setShowPreloader(false));
                Swal.fire({
                    icon: "success",
                    title: "Thay đổi thành công!",
                    showConfirmButton: false,
                    timer: 2000,
                });

                setData((prevData) =>
                    prevData.map((item) =>
                        item.id === id ? { ...item, accept: item.accept === 1 ? 0 : 1 } : item
                    )
                );
            })
            .catch((err) => {
                dispatch(setShowPreloader(false));
                Swal.fire({
                    icon: "error",
                    title: "Thay đổi thất bại!",
                    showConfirmButton: false,
                    timer: 2000,
                });
                AppNotification.showError("Xoá IP thất bại!");
            });
    }

    return (
        <MasterLayout>
            <ThemeBreadcrumb title="Quản lý IP" />

            <div className='row'>
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Thêm IP</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmitForm}>
                                <div className="row">
                                    <div className='col-4'>
                                        <input
                                            type='text'
                                            name='denominations'
                                            className='form-control ms-2'
                                            placeholder='Nhập IP...'
                                            value={ip}
                                            onChange={handleChangeIP}
                                        />
                                    </div>
                                    <div className='col-2 d-flex justify-content-center'>
                                        <div className='input-group-append'>
                                            <button className='btn light btn-primary ms-2' type='button'
                                                    onClick={handleSubmitForm}>
                                                Tạo mới
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Quản lý IP</h4>
                        </div>
                        <div className="card-body">
                            <div className='table-responsive'>
                                <div id="example3_wrapper" className="dataTables_wrapper no-footer">
                                    <div className='row mb-3'>
                                        <div className='col-md-3 d-flex align-items-end'>
                                            <div className="dataTables_length" id="example3_length">
                                                <label>
                                                    Hiển thị{" "}
                                                    <select
                                                        name="example3_length"
                                                        aria-controls="example3"
                                                        className=""
                                                        value={perPage}
                                                        onChange={(e) => handleChangeperPage(e)}
                                                    >
                                                        <option value={1}>1</option>
                                                        <option value={25}>25</option>
                                                        <option value={100}>100</option>
                                                    </select>{" "}
                                                    dữ liệu.
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-md-9 col-12 d-flex justify-content-end'>
                                            <form className='w-100' onSubmit={handleSubmit}>
                                                <div className='row'>
                                                    <div className='col-md-2 offset-md-4 col-12 mb-2'>
                                                        <label className=''>Tìm kiếm : </label>
                                                        <input
                                                            type='text'
                                                            className='form-control ms-2'
                                                            placeholder='IP'
                                                            name='search'
                                                            value={search}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className='col-md-3 col-12'>
                                                        <label className=''>Trạng thái : </label>
                                                        <select
                                                            name="type"
                                                            className="form-control form-control-new"
                                                            value={type}
                                                            onChange={handleChangeType}
                                                        >
                                                            <option value="">Chọn trạng thái</option>
                                                            <option value={1}>Cho phép đăng nhập</option>
                                                            <option value={2}>Không cho phép đăng nhập</option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        className='col-md-3 col-12 d-flex flex-column justify-content-end mb-2'>
                                                        <div className='input-group-append'>
                                                            <button onClick={handleSubmit} className='btn light btn-light ms-2'
                                                                    type='submit'>
                                                                Tìm kiếm
                                                            </button>
                                                            <button onClick={resetFilter} className='btn light btn-danger ms-2'
                                                                    type='button'>
                                                                Xóa
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <table
                                        id="example3"
                                        className="display dataTable no-footer mb-2"
                                        style={{ width: '100%' }}
                                        role="grid"
                                        aria-describedby="example3_info"
                                    >
                                        <thead>
                                        <tr role="row">
                                            <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example3"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="Name: activate to sort column ascending"
                                                style={{width: "10%"}}
                                            >
                                                STT
                                            </th>
                                            <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example3"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="Name: activate to sort column ascending"
                                                style={{width: "40%"}}
                                            >
                                                IP
                                            </th>
                                            <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example3"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="Gender: activate to sort column ascending"
                                            >
                                                TRẠNG THÁI
                                            </th>
                                            <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example3"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="Gender: activate to sort column ascending"
                                            >
                                                NGÀY TẠO
                                            </th>
                                            <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example3"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="Mobile: activate to sort column ascending"
                                            >
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            data.map((item, key) => (
                                                <tr key={key} role="row" className="odd">
                                                    <td>
                                                        <div className="d-flex text-warning">
                                                            {(page - 1) * perPage + key + 1}
                                                        </div>
                                                    </td>
                                                        <td className='text-warning'>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    <span className='text-primary'>{item.ip}</span> <br />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className={`d-flex align-items-center gap-2 ${item.accept === 1 ? 'text-success' :  'text-warning'}`}>
                                                            <button className={`badge ${item.accept ? 'badge-success' :  'badge-warning'}`}
                                                                    onClick={() => changeStatus(item.id)}>
                                                                {{
                                                                    1: "Cho phép đăng nhập",
                                                                    0: "Không cho phép đăng nhập",
                                                                }[item.accept] || ""}
                                                            </button>
                                                        </td>
                                                    <td>{item.created_at_fm}</td>
                                                    <td className='text-danger'>
                                                        <button className="badge badge-danger"
                                                                onClick={() => handleDeleteIp(item.id)}>Xoá
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                    <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MasterLayout>
    );
}

export default IPSettingPage;